import { pushEvent } from 'src/client/data-layer';

export const trackSearchSuggestionsListed = (types: string) => {
  pushEvent('searchSuggestionsListed', { types });
};

export const trackSearchSuggestionClicked = (
  type: string,
  suggestion: string,
  query: string,
  reciprocalRank: number
) => {
  pushEvent('searchSuggestionClicked', {
    type,
    suggestion,
    reciprocalRank,
    query,
  });
};

export const trackSearchHistoryListed = () => {
  pushEvent('searchHistoryListed');
};

export const trackSearchHistoryClicked = (title?: string) => {
  pushEvent('searchHistoryClicked', { title });
};

export const trackSearchHistoryDeleted = (title?: string) => {
  pushEvent('searchHistoryDeleted', { title });
};
